<template>
  <div
    class="question-image-thumbnail aspect-square border rounded
   border-secondary-20 flex items-center justify-center"
  >
    <img :src="imageUrl" class="max-w-full max-h-full" />
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
.question-image-thumbnail {
  --thumbnail-size: 136px;
  width: var(--thumbnail-size);
  min-width: var(--thumbnail-size);
  max-width: var(--thumbnail-size);
  aspect-ratio: 1;
}
</style>
